import { Component, EventEmitter, Output } from '@angular/core';
import { CaptchaService } from '../../../services/captcha.service';

@Component({
    selector: 'payment-resume-pay-button-recaptcha',
    templateUrl: './payment.resume.pay-button.recaptcha.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentResumePayButtonRecaptchaComponent {
    @Output('ready') ready: EventEmitter<string> = new EventEmitter();
    public paymentAttempt = false;

    constructor(private captchaService: CaptchaService) {
        this.captchaService.resolved$.subscribe(token => {
            if (this.paymentAttempt) {
                this.ready.emit(token);
            }
        });
    }

    public executeCaptcha() {
        this.captchaService.requireResolution();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/payment/resume/pay-button/recaptcha/payment.resume.pay-button.recaptcha.component.ts